import ClazzService from "../../services/Clazz";

import useAuthorizedQuery from "../../common/hooks/useAuthorizedQuery";

export const QUERY_KEY = "clazzes";

function useListClazzes() {
  return useAuthorizedQuery(QUERY_KEY, () => ClazzService.listClazzes());
}

export default useListClazzes;
